/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ChartParms } from "@src/app/model/sys/nav-item";
import { User } from "@src/app/model/user";
import { MONTHLY_TYPE, RequestAnalysisComponent, WEEKLY_TYPE } from "@src/app/modules/crm/request-analysis/request-analysis.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const RAPCharts = [
        //{ type: 'pie', picklist: 'omc_managerId' } as ChartParms,
        { type: 'bar', picklist: 'period', trend: 'period', number: 'opened' } as ChartParms,
        { type: 'bar', picklist: 'period', trend: 'period', number: 'closed' } as ChartParms,
        { type: 'trend', picklist: 'periodType', trend: 'period', number: 'daysToClose' } as ChartParms,
        { type: 'pie', picklist: 'totalOpen', number: 'stillOpen', supressSubTitle: true } as ChartParms,
]
export function RAPViews(u: User) {
    if (!u.inAgency) {
        return [
            {
                id: 'omcMonthly',
                name: $localize`Monthly Analysis`,
                helpText: 'Service request volumes and resolution times by month',
                filterFields: { periodType: MONTHLY_TYPE.id, omcId: 'All', period: 'All' },
            },
            {
                id: 'omcWeekly',
                name: $localize`Weekly Analysis`,
                helpText: 'Service request volumes and resolution times by week',
                filterFields: { periodType: WEEKLY_TYPE.id, omcId: 'All', period: 'All' },
            }
        ]
    }

    return [
        {
            id: 'monthly',
            name: $localize`Monthly Analysis`,
            helpText: 'Service request volumes and resolution times by month',
            filterFields: { periodType: MONTHLY_TYPE.id, omcId: 'All', period: 'All' },
        },
        {
            id: 'weekly',
            name: $localize`Weekly Analysis`,
            helpText: 'Service request volumes and resolution times by week',
            filterFields: { periodType: WEEKLY_TYPE.id, omcId: 'All', period: 'All' },
        }
    ]
}

export const RequestAnalysisPageNavRoute = new NavRoute('crm/requestAnalysis', ()=>RequestAnalysisComponent, 'summarize')
    .setCharts(RAPCharts).setViews(RAPViews);
